import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './NumberVerificationModal.css';
import cs from '../../components/commonStyle.css';
import { Modal, FormGroup, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { closeNumberVerificationModal } from '../../actions/modalActions';
import { Field, reduxForm } from 'redux-form';
import messages from '../../locale/messages';
import { sendVerificationSmsLink } from '../../actions/SmsVerification/sendVerificationSmsLink';
import VerificationSuccess from '../VerificationSuccess/VerificationSuccess';
import VerificationLoaderModal from '../VerificationLoaderModal/VerificationLoaderModal';
import VerificationFailedModal from '../VerificationFailedModal/VerificationFailedModal';
const validate = (values) => {
  const errors = {};
  if (!values.phoneNumber) {
    errors.phoneNumber = messages.required;
  }
  else if (!/^\d{10}$/.test(values.phoneNumber)) {
    errors.phoneNumber = messages.invalidPhoneNumber;
  }
  return errors;
};
class NumberVerificationModal extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    sendVerificationSmsLink: PropTypes.func.isRequired,     
  };
  state = {
    showSuccessModal: false,
    isSubmitting: false,
    error: null,
    showLoaderModal: false,
    showFailedModal: false,
    showCodeSuccessModal: false,
    retryAttempted: false,
    copied: false,
  };




  renderFormControl = ({ input, label, type, meta: { touched, error }, className, maxLength }) => {
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('inputFocusColor', cs.positionRelative)}>
        <label>{label}</label>
        <input {...input} placeholder={label} type={type} className={className} maxLength={maxLength} />
        {touched && error && <span className={cs.errorMessage}>{typeof error === 'object' && error.id ? formatMessage(error) : error}</span>}
      </div>
    );
  }

  handleSuccessClose = () => {
    this.setState({ showSuccessModal: false }, () => {
      window.location = '/dashboard';
    });
  };

  handleLoaderClose = () => {
    this.setState({ showLoaderModal: false });
  };

  handleFailedClose = () => {
    this.setState({ showFailedModal: false });
  };

  onSubmit = async (values) => {
    try {
      const { phoneNumber } = values;
      const verificationUrl = this.props.url;
      this.setState({ isSubmitting: true, error: null });

      const result = await this.props.sendVerificationSmsLink({ phoneNumber, verificationUrl });
      if (result.status === '200') {
        this.setState({
          showSuccessModal: true,
          isSubmitting: false,
          showLoaderModal: false,
          showFailedModal: false,
          phoneNumber, // Save phoneNumber to state
        });
      } else {
        this.setState({
          error: result.errorMessage,
          isSubmitting: false,
          showLoaderModal: false,
          showFailedModal: true,
        });
      }
    } catch (error) {
      this.setState({
        error: error.message || 'An unexpected error occurred',
        isSubmitting: false,
        showLoaderModal: false,
        showFailedModal: true,
      });
    }
  };

  render() {
    const { onClose, show, handleSubmit } = this.props;
    const { formatMessage } = this.props.intl;
    const { showSuccessModal, isSubmitting, error, showLoaderModal, showFailedModal } = this.state;

    return (<>
      <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
        <div className={cx(s.sectionBlock)}>
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className={s.verificationContent}>
              <h2 className={cx(s.titleText)}>{formatMessage(messages.numberVerificationTitle)}</h2>
              <p className={cx(s.contentText)}>{formatMessage(messages.numberVerificationInstruction)}</p>
              <form onSubmit={handleSubmit(this.onSubmit)}>
                <FormGroup className={cs.spaceBottom3}>
                  <Field
                    name="phoneNumber"
                    type="tel"
                    component={this.renderFormControl}
                    label={formatMessage(messages.numberVerificationLabel)}
                    className={cx(cs.formControlInput, 'commonInputPaddingRTL', 'form-control')}
                    maxLength={15}
                   // validate={this.validate}
                  />
                  {error && <span className={cs.errorMessage}>{typeof error === 'object' && error.id ? formatMessage(error) : error}</span>}
                </FormGroup>
                {/* <Button className={cx(cs.btnPrimary, cs.fullWidth, cs.commonMediumText)} type="submit">Send SMS Verification Link</Button> */}

                <Button
                                    className={cx(
                                      cs.btnPrimary,
                                      cs.fullWidth,
                                      cs.commonMediumText
                                    )}
                                    type="submit"
                                    disabled={isSubmitting} 
                                  >
                                    {isSubmitting ? formatMessage(messages.numberVerificationSending) : formatMessage(messages.numberVerificationSend)}
                                  </Button>
                </form>
            </div>
          </Modal.Body>
        </div>
      </Modal>

      <VerificationSuccess
        emailOrPhone={this.state.phoneNumber}
        show={showSuccessModal}
        onClose={this.handleSuccessClose}
      />
      <VerificationLoaderModal
        show={showLoaderModal}
        onClose={this.handleLoaderClose}
      />
      <VerificationFailedModal
        show={showFailedModal}
        onClose={this.handleFailedClose}
      />
      </>
    );
  }
}

NumberVerificationModal = reduxForm({
  form: 'NumberVerificationForm',
  validate,
  destroyOnUnmount: true
})(NumberVerificationModal);

const mapState = state => ({
  numberVerificationModal: state.modalStatus.isNumberVerificationModalOpen,
  
});

const mapDispatch = {
  closeNumberVerificationModal,
  sendVerificationSmsLink,
};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(NumberVerificationModal))); 
